import { useState } from "react";
import { useAccount } from "./useAccount";
import { Avviso, Bottone, Campo, LinkTesto, PaginaAccount, Scheda } from "./ui";
import { C } from "../theme/tokens";
import { traccia } from "../consenso/tracciamento";

export const CHIAVE_PIANO_SCELTO = "obscura_piano_scelto";

/** Ricorda il piano scelto dalla pagina prezzi finche' l'account non e' pronto. */
export function ricordaPianoScelto(piano, cadenza) {
  try {
    if (!piano) return;
    localStorage.setItem(CHIAVE_PIANO_SCELTO, JSON.stringify({ piano, cadenza: cadenza || "mensile", ts: Date.now() }));
  } catch (_) { /* niente storage: si sceglie dall'area clienti */ }
}

export function leggiPianoScelto() {
  try {
    const raw = localStorage.getItem(CHIAVE_PIANO_SCELTO);
    if (!raw) return null;
    const dati = JSON.parse(raw);
    if (!dati?.piano || (dati.ts && Date.now() - dati.ts > 7 * 24 * 3600 * 1000)) return null;
    return { piano: dati.piano, cadenza: dati.cadenza || "mensile" };
  } catch (_) { return null; }
}

export function dimenticaPianoScelto() {
  try { localStorage.removeItem(CHIAVE_PIANO_SCELTO); } catch (_) { /* noop */ }
}

export default function RegistrazionePage({ onNavigate, piano, cadenza }) {
  const { api } = useAccount();
  const [azienda, setAzienda] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [privacy, setPrivacy] = useState(false);
  const [errore, setErrore] = useState(null);
  const [inCorso, setInCorso] = useState(false);
  const [fatto, setFatto] = useState(null);
  const [reinviato, setReinviato] = useState(null);

  const invia = async (e) => {
    e.preventDefault();
    if (!privacy) { setErrore("Accetta l'informativa privacy per continuare."); return; }
    setInCorso(true); setErrore(null);
    try {
      const r = await api.registrazione({ email, password, nome, azienda });
      ricordaPianoScelto(piano, cadenza);
      traccia.registrazione();
      setFatto(r.messaggio || "Controlla la posta.");
    } catch (err) {
      setErrore(err.message);
    } finally {
      setInCorso(false);
    }
  };

  const reinvia = async () => {
    try {
      const r = await api.reinviaVerifica(email);
      setReinviato(r.messaggio || "Email inviata.");
    } catch (err) {
      setErrore(err.message);
    }
  };

  if (fatto) {
    return (
      <PaginaAccount titolo="Controlla la posta" onBack={() => onNavigate("landing")}>
        <Scheda titolo="Ti abbiamo scritto">
          <p style={{ fontSize: 14, color: C.textBody, lineHeight: 1.6, margin: "0 0 14px" }}>
            {fatto} L&apos;abbiamo inviata a <strong>{email}</strong>: apri il link per confermare l&apos;indirizzo e attivare l&apos;account. Se non la vedi, guarda nello spam.
          </p>
          {reinviato ? <Avviso tipo="ok">{reinviato}</Avviso> : (
            <p style={{ fontSize: 13, color: C.textNum, margin: "0 0 14px" }}>
              Non e&apos; arrivata? <LinkTesto onClick={reinvia}>Reinvia l&apos;email</LinkTesto>
            </p>
          )}
          {errore && <Avviso tipo="errore">{errore}</Avviso>}
          <Bottone variante="secondario" onClick={() => onNavigate("accesso")}>Vai all&apos;accesso</Bottone>
        </Scheda>
      </PaginaAccount>
    );
  }

  return (
    <PaginaAccount titolo="Crea un account" sottotitolo={piano ? `Stai attivando il piano ${piano.charAt(0).toUpperCase() + piano.slice(1)}: prima serve un account aziendale, poi il pagamento.` : "Un account aziendale per usare OBSCURA in abbonamento e lavorare in team."} onBack={() => onNavigate("landing")}>
      <Scheda>
        <form onSubmit={invia}>
          <Campo etichetta="Azienda o studio" valore={azienda} onChange={setAzienda} autoComplete="organization" />
          <Campo etichetta="Il tuo nome" valore={nome} onChange={setNome} autoComplete="name" />
          <Campo etichetta="Email di lavoro" tipo="email" valore={email} onChange={setEmail} autoComplete="email" />
          <Campo etichetta="Password" tipo="password" valore={password} onChange={setPassword} autoComplete="new-password" minLength={10} aiuto="Almeno 10 caratteri." />
          <label style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 12, color: C.textBody, lineHeight: 1.5, margin: "4px 0 16px", cursor: "pointer" }}>
            <input type="checkbox" checked={privacy} onChange={() => setPrivacy((p) => !p)} style={{ width: 16, height: 16, accentColor: C.smartBlue, marginTop: 2, flexShrink: 0 }} />
            <span>Ho letto l&apos;<a href="?page=privacy" target="_blank" rel="noopener noreferrer" style={{ color: C.smartBlue, fontWeight: 600 }}>informativa privacy</a> e accetto il trattamento dei dati dell&apos;account.</span>
          </label>
          {errore && <Avviso tipo="errore">{errore}</Avviso>}
          <Bottone tipo="submit" pieno disabilitato={inCorso}>{inCorso ? "Creazione in corso..." : "Crea l'account"}</Bottone>
        </form>
      </Scheda>
      <p style={{ fontSize: 13, color: C.textNum, textAlign: "center", margin: 0 }}>
        Hai gia&apos; un account? <LinkTesto onClick={() => onNavigate("accesso")}>Accedi</LinkTesto>
      </p>
    </PaginaAccount>
  );
}
